// extracted by mini-css-extract-plugin
module.exports = {"content":"Tabs_content__36I5c","hidden":"Tabs_hidden__UcsjL"};